import React from "react";
import { Dropdown, IDropdownStyles } from "@fluentui/react";
import { connect } from "react-redux";

class QuotaChange extends React.Component {
  constructor(props) {
    super(props);
    this.state = { possibilities: [] };
  }

  componentDidMount(): void {
    const { quotas, quota, user } = this.props;

    let filtered = quotas.filter(
      (x) =>
        x.location.locationType === quota.location.locationType &&
        x.quotaSize >= quota.quotaSize
    );

    if (user.role !== "Administrator") {
      filtered = filtered.filter(
        (x) => x.quotaSize <= 2200 || x.id === quota.id
      );
    }

    filtered.sort((a, b) => a.quotaSize - b.quotaSize);

    this.setState({
      possibilities: filtered.map((x) => ({
        key: x.id,
        text: `${x.quotaSize} GB`,
      })),
    });
  }

  change(e, v) {
    this.props.onUpdate("quotaId", v.key);
  }

  render() {
    return (
      <div style={{ marginTop: "10px" }}>
        Request for quota change
        <Dropdown
          placeholder="Choose quota"
          onChange={this.change.bind(this)}
          disabled={this.props.disabled || this.props.isreadonly}
          defaultSelectedKey={this.props.quota.id}
          options={this.state.possibilities}
          styles={dropdownStyles}
        />
      </div>
    );
  }
}

const dropdownStyles: Partial<IDropdownStyles> = {
  dropdown: { width: 200, marginTop: 6 },
};

const mapStateToProps = (state) => ({
  quotas: state.app.siteQuotas,
});

export default connect(mapStateToProps, null)(QuotaChange);



// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/QuotaChange.js